<template>
  <div class="k-page-content">
    <el-tabs v-model="activeName" class="box-eltab">
      <el-tab-pane label="账户管理" name="first">
        <div class="k-page-common">
          <div class="k-common-header">
            <div class="k-filter-option k-filter-input">
              <el-input
                placeholder="请输入账户ID或名称"
                v-model="searchForm.name"
                :size="size"
                clearable
                @change="doSearch"
              >
                <template slot="prepend">账户名称：</template>
              </el-input>
            </div>
          </div>
          <div class="k-common-con">
            <div class="k-table-wrapper">
              <div class="k-table-toolbar">
                <div>
                  <el-button
                    style="margin-right:5px;"
                    :size="size"
                    type="primary"
                    @click="openMedia"
                    v-if="$parent.$parent.isAuthAction('index/v1.QianchuanAuth/index')"
                  >操作授权<i class="el-icon-user el-icon--right"></i></el-button>
                  <el-button
                    style="margin-right:15px;"
                    :size="size"
                    type="primary"
                    @click="taskList"
                    v-if="$parent.$parent.isAuthAction('home/v1.task/getCrontabList')"
                  >执行进度<i class="el-icon-tickets el-icon--right"></i></el-button>
                  <el-dropdown
                    trigger="click"
                    @command="handleCommand"
                    v-if="$parent.$parent.isAuthAction('home/v1.userAdvertisers/allAction')"
                  >
                    <el-button type="primary" :size="size" style="margin-right:5px;">
                      批量操作
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="owner">分配所有者</el-dropdown-item>
                      <el-dropdown-item command="collaborators">分配协作着</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                 
                </div>
              </div>
              <div class="k-table-con">
                <el-table
                  :data="tableData.data"
                  border
                  style="width: 100%"
                  @selection-change="handleSelectionChange"
                >
                  <el-table-column type="selection" width="55"></el-table-column>
                  <el-table-column prop="advertiser_id" label="广告主ID" width="180"></el-table-column>
                  <el-table-column fixed="left" prop="name" label="广告主名称" width="250"></el-table-column>
                  <el-table-column prop="status_text" label="状态" width="80">
                    <template slot-scope="scope">
                      <el-tag
                        type="success"
                        :size="size"
                        v-if="scope.row.status == 'YES'"
                      >{{scope.row.status_text}}</el-tag>
                      <el-tag
                        type="danger"
                        :size="size"
                        v-if="scope.row.status == 'NO'"
                      >{{scope.row.status_text}}</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="first_industry_name" label="一级行业名称" width="150"></el-table-column>
                  <el-table-column prop="second_industry_name" label="二级行业名称" width="150"></el-table-column>
                  <el-table-column prop="companyName" label="所属户" width="150"></el-table-column>
                  <el-table-column prop="projectName" label="所属项目" width="150"></el-table-column>
                  <el-table-column prop="nickname" label="所属操作人" width="100"></el-table-column>
                  <el-table-column prop="remark" label="备注" width="200"></el-table-column>
                  <el-table-column prop="create_time" label="创建时间" width="200"></el-table-column>
                  <el-table-column fixed="right" label="操作" min-width="200">
                    <template slot-scope="scope">
                      <el-button
                        type="text"
                        :size="size"
                        class="c-danger"
                        @click="editCustomer(scope.row)"
                        v-if="$parent.$parent.isAuthAction('home/v1.userAdvertisers/edit')"
                      >编辑</el-button>
                      <el-button
                        type="text"
                        :size="size"
                        v-if="scope.row.status == 'NO' && $parent.$parent.isAuthAction('home/v1.userAdvertisers/status')"
                        @click="updateCustomer(scope.row)"
                      >开启</el-button>
                      <el-button
                        type="text"
                        :size="size"
                        v-if="scope.row.status == 'YES' && $parent.$parent.isAuthAction('home/v1.userAdvertisers/status')"
                        style="color:red"
                        @click="updateCustomer(scope.row)"
                      >关闭</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  background
                  ref="pagination"
                  @current-change="handleCurrentChange"
                  :current-page="tableData.current_page | number"
                  :page-size="tableData.per_page | number"
                  layout="total, prev, pager, next, jumper"
                  :total="tableData.total | number"
                ></el-pagination>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-drawer custom-class="k-drawer" :visible.sync="editFormVisiable" direction="rtl" size="50%">
      <el-form :model="editForm" label-width="110px" :size="size">
        <div class="drawer-header">
          <div class="header-title">
            <span>编辑账户</span>
            <i class="el-icon-close k-drawer-close" @click="editFormVisiable = false"></i>
          </div>
        </div>
        <div class="drawer-content">
          <el-form-item label="账户名称:">
            <el-input placeholder="请输入账户名称" v-model="editForm.name" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="账户ID:">
            <el-input placeholder="请输入账户ID" v-model="editForm.guestId" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="账户所属:">
            <el-select
              style="width: 100%"
              v-model="editForm.account"
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="remoteMethodAccount"
            >
              <el-option
                v-for="item in accounts"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="账户项目:">
            <el-row>
              <el-col :span="18">
                <el-select
                  style="width: 100%"
                  v-model="editForm.pid"
                  remote
                  reserve-keyword
                  placeholder="请输入关键词"
                  :remote-method="getProjectLists"
                >
                  <el-option
                    v-for="item in projects"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-col>
              <el-col :span="6" v-if="info.views.isSupper==1 || info.views.isManager==1">
                <el-button
                  type="primary"
                  :size="size"
                  style="margin-left:5px;"
                  @click="addProjectOpen"
                >添加</el-button>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="协作者(多选):">
            <el-select
              style="width: 100%"
              v-model="editForm.collaborator"
              multiple
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="remoteMethod"
            >
              <el-option
                v-for="item in collaborators"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注:">
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4}"
              placeholder="请输入备注内容"
              v-model="editForm.remark"
            ></el-input>
          </el-form-item>
          <el-form-item label="状态:">
            <el-radio-group v-model="editForm.status">
              <el-radio-button label="YES">开启</el-radio-button>
              <el-radio-button label="NO">关闭</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </div>
        <div class="drawer-footer">
          <el-button type="primary" @click="handleTableAccount" :size="size">提 交</el-button>
          <el-button :size="size" @click="editFormVisiable = false">取消</el-button>
        </div>
      </el-form>
    </el-drawer>
    <el-dialog title="批量操作" width="30%" :visible.sync="dialogTableVisible">
      <el-form :model="form" ref="form" :size="size" :rules="rules.form" label-width="80px">
        <el-form-item label="所属人:" v-if="form.formHide == 'owner'" prop="owner">
          <el-select
            style="width: 100%"
            v-model="form.owner"
            filterable
            remote
            reserve-keyword
            placeholder="请输入关键词"
            :remote-method="remoteMethodAccount"
          >
            <el-option
              v-for="item in accounts"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="协作者:" v-if="form.formHide == 'collaborators'" prop="collaborators">
          <el-select
            style="width: 100%"
            v-model="form.collaborators"
            multiple
            filterable
            remote
            reserve-keyword
            placeholder="请输入关键词"
            :remote-method="remoteMethod"
          >
            <el-option
              v-for="item in collaborators"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false" :size="size">取 消</el-button>
        <el-button type="primary" @click="allAction" :size="size">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="授权账户" width="70%" :visible.sync="accountTableVisible">
      <el-form :inline="true" :size="size" :model="accountForm">
        <el-form-item label="账户ID">
          <el-input v-model="accountForm.name" clearable></el-input>
        </el-form-item>
        <el-form-item label="公司主体">
          <el-input v-model="accountForm.company" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getAccountData">搜索</el-button>
        </el-form-item>
      </el-form>
      <el-table
        ref="aTable"
        :data="accountTable.data"
        max-height="300"
        border
        @selection-change="handleSelection"
      >
        <el-table-column type="selection" :selectable="checkSelectable" width="55"></el-table-column>
        <el-table-column property="advertiser_id" label="账户ID" min-width="150"></el-table-column>
        <el-table-column property="name" label="账户名" min-width="200"></el-table-column>
        <el-table-column property="company" label="账户主体" min-width="200"></el-table-column>
        <el-table-column property="nickname" min-width="100" label="所属人员"></el-table-column>
      </el-table>
      <el-pagination
        background
        ref="pagination"
        @current-change="handleCurrentChangeAccount"
        :current-page="accountTable.current_page | number"
        :page-size="accountTable.per_page | number"
        layout="total, prev, pager, next, jumper"
        :total="accountTable.total | number"
      ></el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button :size="size" @click="accountTableVisible = false">取 消</el-button>
        <el-button :size="size" type="primary" @click="clickRelevance">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="账户进度" :visible.sync="taskDialog" width="720px" @closed="clearInterval">
      <el-table :data="taskTable.data" border max-height="300">
        <el-table-column property="id" label="任务ID" width="80"></el-table-column>
        <el-table-column property="mediaName" label="任务详情" width="250">
          <template slot-scope="scope">
            <span>{{ scope.row.mediaName }} ({{ scope.row.third_id }})</span>
          </template>
        </el-table-column>
        <el-table-column label="任务进度" width="250">
          <template slot-scope="scope">
            <p style="font-size:10px">
              执行进度:{{format(scope.row.percent)}}  {{scope.row.schedule}}/{{scope.row.total}}
            </p>
            <p style="font-size:10px">
              创建时间:{{scope.row.create_time}}
            </p>
          </template>
        </el-table-column>
        <el-table-column property="status" label="状态">
          <template slot-scope="scope">
            <el-tag size="mini" v-if="scope.row.status == 'draft'">草稿</el-tag>
            <el-tag size="mini" v-if="scope.row.status == 'executory'">执行中</el-tag>
            <el-tag size="mini" v-if="scope.row.status == 'start'">进行中</el-tag>
            <el-tag size="mini" v-if="scope.row.status == 'end'">结束</el-tag>
          </template>
        </el-table-column>
        <el-table-column property="create_time" label="操作" width="80">
          <template slot-scope="scope">
            <el-button type="text" v-if="scope.row.status=='draft'" @click="startTask(scope.row.id)">开启任务</el-button>
            <el-button
              type="text"
              :size="size"
              class="c-danger"
              @click="getAccount(scope.row.third_id)"
              v-if="$parent.$parent.isAuthAction('home/v1.userAdvertisers/list') && scope.row.status == 'end'"
            >分配账户</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        ref="pagination"
        @current-change="handleCurrentChangeTask"
        :current-page="taskTable.current_page | number"
        :page-size="taskTable.per_page | number"
        layout="total, prev, pager, next, jumper"
        :total="taskTable.total | number"
      ></el-pagination>
    </el-dialog>

    <el-dialog title="添加项目" width="500px" :visible.sync="addProjectVisible">
      <el-form label-width="80px" :model="projectForm">
        <el-form-item label="项目名称">
          <el-input placeholder="请填写项目名称" v-model="projectForm.name" style="width:340px;"></el-input>
        </el-form-item>
        <el-form-item label="项目备注">
          <el-input
            v-model="projectForm.note"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 3}"
            placeholder="请输入备注"
            style="width:340px"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addProjectVisible = false" :size="size">取 消</el-button>
        <el-button type="primary" @click="addProject" :size="size">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="媒体授权" :visible.sync="dialogMediaVisible">
      <el-form
        ref="mediaForm"
        :model="mediaForm"
        :size="size"
        :rules="rules.mediaRules"
        label-width="200px"
      >
        <el-form-item label="需要授权的媒体" prop="mediaId">
          <el-select v-model="mediaForm.mediaId" clearable placeholder="请选择媒体">
            <el-option
              v-for="item in mediaOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :size="size" @click="dialogMediaVisible = false">取 消</el-button>
        <el-button type="primary" :size="size" @click="actionUrl">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: ['info'],

  data() {
    return {
      editFormVisiable: false,
      dialogTableVisible: false,
      accountTableVisible: false,
      dialogMediaVisible: false,
      timer: '',
      infoData: {
        show: false,
        total: '计算中',
        schedule: '0'
      },
      taskDialog: false,
      accountTable: {
        total: 0,
        per_page: 100,
        current_page: 1,
        last_page: 0,
        data: []
      },
      taskTable: {
        total: 0,
        per_page: 100,
        current_page: 1,
        last_page: 0,
        data: []
      },
      accountForm: {
        name: '',
        company: ''
      },
      projectForm: {
        name: '',
        note: ''
      },
      isCollapse: false,
      activeClass: 'el-icon-s-fold',
      activeName: 'first',
      slidewidth: 160,
      loading: false,
      size: 'mini',
      searchForm: {
        name: '',
        status: ''
      },
      form: {
        formHide: 'owner',
        ids: [],
        owner: '',
        collaborators: []
      },
      accounts: [],
      projects: [],
      collaborators: [],
      resetSearch: {
        name: '',
        status: ''
      },
      mediaOptions: [],
      options: [
        {
          value: 'STATUS_DISABLE',
          label: '已禁用'
        },
        {
          value: 'STATUS_PENDING_CONFIRM',
          label: '申请待审核'
        },
        {
          value: 'STATUS_PENDING_VERIFIED',
          label: '待验证'
        },
        {
          value: 'STATUS_CONFIRM_FAIL',
          label: '审核不通过'
        },
        {
          value: 'STATUS_ENABLE',
          label: '已审核'
        },
        {
          value: 'STATUS_CONFIRM_FAIL_END',
          label: 'CRM审核不通过'
        },
        {
          value: 'STATUS_PENDING_CONFIRM_MODIFY',
          label: '修改待审核'
        },
        {
          value: 'STATUS_CONFIRM_MODIFY_FAIL',
          label: '修改审核不通过'
        },
        {
          value: 'STATUS_LIMIT',
          label: '限制'
        },
        {
          value: 'STATUS_WAIT_FOR_BPM_AUDIT',
          label: '等待CRM审核'
        },
        {
          value: 'STATUS_WAIT_FOR_PUBLIC_AUTH',
          label: '待对公验证'
        },
        {
          value: 'STATUS_SELF_SERVICE_UNAUDITED',
          label: '自助开户待验证资质'
        }
      ],
      checked: false,
      viewId: '',
      ids: [],
      searchForm: {},
      tableData: {
        total: 0,
        per_page: 15,
        current_page: 1,
        last_page: 0,
        data: []
      },
      mediaForm: {
        mediaId: ''
      },
      interval:'',
      editForm: {
        id: '',
        company_id: '',
        name: '',
        guestId: '',
        account: '',
        collaborator: [],
        remark: '',
        status: 'YES',
        pid: ''
      },
      rules: {
        form: {
          owner: [
            { required: true, message: '请选择账户所属者', trigger: ['change'] }
          ],
          collaborators: [
            { required: true, message: '请选择账户协作者', trigger: ['change'] }
          ]
        },
        mediaRules: {
          mediaId: [
            {
              required: true,
              message: '请选择需要授权的媒体',
              trigger: ['change']
            }
          ]
        }
      },
      addProjectVisible: false
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val)
    }
  },
  computed: {
    apiMainHeight: function() {
      var height = window.innerHeight - 200
      return {
        height: height + 'px',
        border: '1px solid #DCDFE6',
        'margin-bottom': '10px'
      }
    }
  },
  beforeDestroy() {
    // 在组件销毁前清除定时器
    this.clearInterval();
  },
  methods: {
    startTask(id){
      this.$api.http.post('adPromotion/startTask',{id:id}).then(res => {
        if(res.code == 0){
            this.taskTable.data.forEach(function(item,index){
              if(item.id == id){
                this.$set(this.taskTable.data[index],'status','executory')
              }
            }.bind(this))
            this.$message.success('拉取广告主任务开启成功')
        }else{
          this.$message.error(res.message)
        }
      })
    },
    clearInterval(){
      if(this.interval){
        clearInterval(this.interval);
      }
    },
    format(percentage) {
      
      if(percentage === 0){
        var txt = '等待中'
      }else if(percentage === 100){
        var txt = '完成'
      }else{
        var txt = `${percentage}%`
      }
      return txt
    },
    getMediaSelect: function() {
      this.$api.http.get('media/mediaSelect').then(res => {
        this.mediaOptions = res
        this.dialogMediaVisible = true
      })
    },
    addProject: function() {
      //home_v1_user_advertisers_addProject
      this.$api.adPromotion.addProject(this.projectForm).then(res => {
        if (res.code === 0) {
          this.addProjectVisible = false
          this.$message({
            showClose: true,
            message: '添加成功',
            type: 'success'
          })
          this.getProjectLists('')
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: 'error'
          })
        }
      })
    },
    //获取项目列表
    getProjectLists: function(query) {
      this.$api.adPromotion.getProjectLists({ name: query }).then(res => {
        if (res.code === 0) {
          this.projects = res.data
        }
      })
    },
    //更新状态
    updateCustomer: function(row) {
      //home_v1_userAdvertisers_status
      this.$confirm('确定更新账户状态吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(
        function() {
          this.loading = true
          this.$api.adPromotion
            .updateCustomer({ id: row.id, status: row.status })
            .then(res => {
              if (res.code === 0) {
                var data = this.tableData.data
                data.forEach(
                  function(item, index) {
                    if (row.id == item.id) {
                      this.$set(data, index, res.data)
                    }
                  }.bind(this)
                )
                this.$message({
                  showClose: true,
                  message: '更新状态信息成功！',
                  type: 'success'
                })
              } else {
                var message = '更新状态信息失败！'
                if (res.message) {
                  message = res.message
                }
                this.$notify({
                  showClose: true,
                  message: message,
                  type: 'warning'
                })
              }
              this.loading = false
            })
        }.bind(this)
      )
    },
    handleSelectionChange: function(vals) {
      var ids = vals.map(x => x['id'])
      this.form.ids = ids
    },
    //批量操作
    allAction: function() {
      //home_v1_userAdvertisers_all
      this.$refs['form'].validate(
        function(valid) {
          if (valid) {
            this.$api.adPromotion.allAction(this.form).then(res => {
              if (res.code === 0) {
                this.handleSearch(this.searchForm)
                this.dialogTableVisible = false
                this.$message({
                  showClose: true,
                  message: '批量操作成功！',
                  type: 'success'
                })
              }
            })
          } else {
            this.$message({
              showClose: true,
              message: '请填写正确的信息！',
              type: 'warning'
            })
          }
        }.bind(this)
      )
    },
    handleCommand: function(commond) {
      if (this.form.ids.length > 0) {
        // 获取权限内用户
        this.getUserInfo('', '')
        this.dialogTableVisible = true
        this.form.formHide = commond
      } else {
        this.$message({
          showClose: true,
          message: '请先选择批量的账户',
          type: 'error'
        })
      }
    },
    // 获取权限内人员
    getUserInfo: function(query, type) {
      //home_v1_userAdvertisers_user
      this.$api.adPromotion.getUserInfo({ query: query }).then(res => {
        if (res.code === 0) {
          if (type == 'account') {
            this.accounts = res.data
          } else if (type == 'collaborator') {
            this.collaborators = res.data
          } else {
            this.accounts = this.collaborators = res.data
          }
        }
      })
    },
    //获取协作者和所有者
    remoteMethodAccount: function(query) {
      this.getUserInfo(query, 'account')
    },
    //获取协作者和所有者
    remoteMethod: function(query) {
      this.getUserInfo(query, 'collaborator')
    },
    //提交编辑数据
    handleTableAccount: function() {
      //home_v1_userAdvertisers_userEdit
      this.$api.adPromotion.handleTableAccount(this.editForm).then(res => {
        if (res.code === 0) {
          var data = this.tableData.data
          data.forEach(
            function(item, index) {
              if (item.id == res.data.id) {
                this.$set(data, index, res.data)
              }
            }.bind(this)
          )
          this.$message({
            showClose: true,
            message: '修改用户信息成功！',
            type: 'success'
          })
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: 'error'
          })
        }
        this.editFormVisiable = false
      })
      //请求授权地址 home_v1_userAdvertisers_userEdit
    },
    //打开编辑抽屉
    editCustomer: function(item) {
      this.editFormVisiable = true
      this.editForm.id = item.id
      this.editForm.name = item.name
      this.editForm.company_id = item.company_id
      this.editForm.guestId = item.advertiser_id
      this.editForm.account = item.uid
      this.editForm.collaborator = item.cid
      this.editForm.status = item.status
      this.editForm.remark = item.remark
      this.editForm.pid = item.pid
      //获取权限内用户
      this.getUserInfo('', '')
      this.getProjectLists('')
    },
    openMedia: function() {
      this.getMediaSelect()
    },
    actionUrl: function() {
      //index_v1_index_qianchuan_auth_index
      this.$refs['mediaForm'].validate(
        function(valid) {
          if (valid) {
            this.$api.adPromotion.actionUrl(this.mediaForm).then(res => {
              if (res.code === 0) {
                window.location.href = res.data.authUrl
              } else if (res.code === 100) {
                this.$message({
                  showClose: true,
                  message:
                    '每日首次更新获取账户信息，速度较慢!更具账户的数量,需要5-10分钟，请耐心等待，不要重复点击授权。可在当前页面【执行进度】中查看完成进度',
                  type: 'success'
                })
                this.dialogMediaVisible = false
              } else {
                this.$message({
                  showClose: true,
                  message: '获取授权地址失败！',
                  type: 'error'
                })
              }
            })
          }
        }.bind(this)
      )
    },
    reset: function() {
      this.searchForm = this.resetSearch
      this.doSearch()
    },
    resetStatus: function() {
      this.searchForm.status = ''
    },
    // 执行查询
    doSearch: function(event) {
      var query = this.searchForm
      query['_t'] = Date.parse(new Date())

      this.$router.push({ path: this.$route.path, query: query })
    },

    // 排序
    sortChange: function(e) {
      var order
      var prop = e.prop
      if (e.order == 'ascending') {
        order = 'asc'
      } else if (e.order == 'descending') {
        order = 'desc'
      } else {
        prop = this.resetSearch.prop
        order = this.resetSearch.order
      }
      this.handleSearch(this.searchForm, 1, prop, order)
    },

    // 改变当前页 page
    handleCurrentChange: function(val) {
      this.handleSearch(this.searchForm, val)
    },
    // 公共请求接口
    handleSearch: function(params, page, prop, order) {
      this.loading = true
      var param = Object.assign({}, params)
      param['page'] = page ? page : 1
      param['prop'] = prop ? prop : 'id'
      param['order'] = order ? order : 'desc'
      this.$api.adPromotion.getAccountData(param).then(res => {
        if (res.code === 0) {
          this.tableData = res.data
          this.$message({
            showClose: true,
            message: '查询应用列表信息成功！',
            type: 'success'
          })
        } else {
          var message = '查询应用列表信息失败！'
          if (res.message) {
            message = res.message
          }
          this.$message({
            showClose: true,
            message: message,
            type: 'error'
          })
        }
        this.loading = false
      })
    },
    // 生成查询参数
    makeParams: function(query, data) {
      var params = {}
      params['status'] = this.searchForm.status
        ? this.searchForm.status
        : this.resetSearch.status
      params['name'] = this.searchForm.name
        ? this.searchForm.name
        : this.resetSearch.name
      this.searchForm = params
      return params
    },
    getAccount: function(viewId) {
      this.viewId = viewId
      this.getAccountData({})
    },
    getAccountData: function(params, page, prop) {
      //home_v1_userAdvertisers_list
      params['lastid'] = this.viewId
      params['isView'] = true
      params['name'] = this.accountForm.name
      params['company'] = this.accountForm.company

      params['page'] = page ? page : 1
      params['prop'] = prop ? prop : 'id'
      params['order'] = 'desc'
      this.$api.adPromotion.getAccountData(params).then(res => {
        if (res.code == 0) {
          this.accountTable = res.data
          this.accountTableVisible = true
        }
      })
    },
    checkSelectable: function(row) {
      return row.uid == 0
    },
    //授权账户翻页
    handleCurrentChangeAccount: function(val) {
      this.getAccountData(this.searchForm, val)
    },
    handleCurrentChangeTask: function(val) {
      this.getTaskList(val)
      // this.clearInterval();
      // this.interval = setInterval(this.getTaskList(val), 3000);
    },
    //多选账户出发
    handleSelection: function(vals) {
      var ids = vals.map(x => x['id'])
      this.ids = ids
    },
    //关联账户
    clickRelevance: function() {
      if (this.ids.length <= 0) {
        this.$message({
          showClose: true,
          message: '请先选择需要分配的账户',
          type: 'error'
        })
        return
      } else {
        //home_v1_userAdvertisers_updateUid
        this.$api.adPromotion.clickRelevance({ ids: this.ids }).then(res => {
          if (res.code == 0) {
            this.$router.replace('/customer')
            this.accountTableVisible = false
          } else {
            this.$message({
              showClose: true,
              message: '分配账户失败',
              type: 'warning'
            })
          }
        })
      }
    },
    //添加项目
    addProjectOpen: function() {
      this.addProjectVisible = true
    },
    taskList: function() {
      this.getTaskList()
      // this.clearInterval();
      // this.interval = setInterval(this.getTaskList, 3000);
      this.taskDialog = true
    },
    getTaskList: function(page) {
      //home_v1_task_getCrontabList
      this.$api.adPromotion
        .getTaskList({
          page: page ? page : 1,
          prop: 'id',
          order: 'desc'
        })
        .then(res => {
          this.taskTable = res.data
        })
    },
    addTask: function() {
      //home_v1_task_addTask
      this.$api.adPromotion.addTask({ lastid: this.viewId }).then(res => {
        if (res.code == 0) {
          this.$alert(
            '每日首次更新获取账户信息，速度较慢!更具账户的数量,需要5-10分钟，请耐心等待，不要重复点击授权。可在当前页面【执行进度】中查看分配账户',
            '注意',
            {
              confirmButtonText: '已知悉'
            }
          )
        }
        this.$router.replace('/customer')
      })
    }
  },
  beforeRouteUpdate: function(to, from, next) {
    var params = this.makeParams(to.query)
    this.handleSearch(params)
    next()
  },
  mounted: function() {
    var id = this.$viewUrl('lastauth')
    if (id) {
      this.viewId = id
      this.addTask()
    }
    var params = this.makeParams()
    this.handleSearch(params)
  }
}
</script>
<style scoped>